import React from 'react';
import ReactFlow, { Handle } from 'reactflow';
import NodeEditOptions from './nodeEditOptions';
import { MdEmail, MdOutlineTimer, MdOutlineSms, MdError } from "react-icons/md";
import { GrTrigger } from "react-icons/gr";
import { PiArrowsSplitFill } from "react-icons/pi";

// Node type definitions with their respective icons and labels
const NODE_TYPES = {
  TRIGGER: {
    icon: <GrTrigger />,
    label: 'Trigger',
    color: 'orange'
  },
  WAIT: {
    icon: <MdOutlineTimer />,
    label: 'Wait',
    color: 'green'
  },
  EMAIL: {
    icon: <MdEmail />,
    label: 'Email',
    color: 'blue'
  },
  SMS: {
    icon: <MdOutlineSms />,
    label: 'SMS',
    color: 'yellow'
  },
  CONDITIONAL: {
    icon: <PiArrowsSplitFill />,
    label: 'Conditional',
    color: 'purple'
  },
  DEFAULT: {
    icon: <MdError />,
    label: '[ERROR] No action type specified. Please contact support.',
    color: 'red'
  }
};

function FlowsNode(props) {
  const { id, data, selected, position } = props;
  
  const nodeType = NODE_TYPES[data.action] || NODE_TYPES.DEFAULT;

  const handleDelete = () => {
    // Implement delete functionality
    console.log('Delete node:', id);
  };
  
  const handlePreview = () => {
    // Implement preview functionality
    console.log('Preview node:', id);
  };

  return (
    <div className="flows-node-container">
        <div className="flows-node">
          <Handle type="target" position="top" isConnectable={false} />

        {/* header */}
        <div className="flows-node header">
          {/* icon */}
          <div className="flows-node header-icon">
              {nodeType.icon}          
          </div>

          {/* label */}
          <div className="flows-node header-label">
            {nodeType.label}
          </div>

          {/* actions */}
          <div className="flows-node header-actions"> 
            <NodeEditOptions 
              onDelete={handleDelete}
              onPreview={handlePreview}
            />
          </div>
        </div>

        {/* body */}
        <div className="flows-node body">
          {data.label}
        </div>
        <Handle type="source" position="bottom" isConnectable={false} />
      </div>
    </div>
  );
}

export default FlowsNode;